<template>
  <div>
    <div class="p-d-flex p-flex-column" v-if="!updateContact">
      <span>{{ __("Company Name") }}:</span>
      <p-vue-input-text v-model="supplierLocal.Company" />
      <i-form-error :data="errors.Company" />
    </div>
    <div class="grid" v-if="!updateContact">
      <div class="p-d-flex p-flex-column p-mt-2">
        <span>{{ __("Main domain") }}:</span>
        <p-vue-dropdown
          :options="groupsOptions"
          :optionLabel="'GroupName'"
          :optionValue="GroupID"
          :filter="groupsOptions.length > 10"
          v-model="supplierLocal.GroupIDValue"
          class="dropdown"
        >
          <template #value="{ value, placeholder}">
            <div class="inner p-d-flex p-jc-between">
              <span class="value">{{
                value ? value.GroupName : placeholder
              }}</span>
              <span class="icon">
                <i-icon name="arrow" />
              </span>
            </div>
          </template>
        </p-vue-dropdown>
        <i-form-error :data="errors.GroupID" />
      </div>
      <div class="p-d-flex p-flex-column p-mt-2">
        <span>{{ __("Secondary domain") }}:</span>
        <p-vue-dropdown
          :options="servicesOptions"
          :optionLabel="'SSType'"
          :optionValue="SSID"
          :filter="servicesOptions.length > 10"
          v-model="supplierLocal.ssTypeIDValue"
          class="dropdown"
        >
          <template #value="{ value, placeholder}">
            <div class="inner p-d-flex p-jc-between">
              <span class="value">{{
                value ? value.SSType : placeholder
              }}</span>
              <span class="icon">
                <i-icon name="arrow" />
              </span>
            </div>
          </template>
        </p-vue-dropdown>
        <i-form-error :data="errors.SSID" />
      </div>
      <div class="p-d-flex p-flex-column p-mt-2">
        <span>{{ __("Address") }}:</span>
        <p-vue-input-text v-model="supplierLocal.address" />
      </div>
      <div class="p-d-flex p-flex-column p-mt-2">
        <span>{{ __("Website") }}:</span>
        <p-vue-input-text v-model="supplierLocal.Website" />
      </div>
    </div>
    <div v-if="!IsEdit || updateContact">
      <div class="grid">
        <div class="p-d-flex p-flex-column p-mt-2">
          <span>{{ __("First name") }}:</span>
          <p-vue-input-text v-model="supplierLocal.FirstName" />
        </div>
        <div class="p-d-flex p-flex-column p-mt-2">
          <span>{{ __("Last name") }}:</span>
          <p-vue-input-text v-model="supplierLocal.LastName" />
        </div>
        <div class="p-d-flex p-flex-column p-mt-2">
          <span>{{ __("Office phone") }}:</span>
          <p-vue-input-text v-model="supplierLocal.TelWork" />
        </div>
        <div class="p-d-flex p-flex-column p-mt-2">
          <span>{{ __("Mobile") }}:</span>
          <p-vue-input-text v-model="supplierLocal.TelMobile" />
        </div>
        <div class="p-d-flex p-flex-column p-mt-2">
          <span>{{ __("Fax") }}:</span>
          <p-vue-input-text v-model="supplierLocal.FaxWork" />
        </div>
        <div class="p-d-flex p-flex-column p-mt-2">
          <span>{{ __("role") }}:</span>
          <p-vue-input-text v-model="supplierLocal.Position" />
        </div>
      </div>
      <div class="p-d-flex p-flex-column p-mt-2">
        <span>{{ __("Email") }}:</span>
        <p-vue-input-text v-model="supplierLocal.Email" />
        <i-form-error :data="errors.Email" />
      </div>
    </div>
    <div class="p-d-flex p-flex-column p-mt-2" v-if="!updateContact">
      <span>{{ __("Comments") }}:</span>
      <p-vue-textarea
        :autoResize="true"
        rows="4"
        class="p-inputtext--alt"
        v-model="supplierLocal.Notes"
      />
    </div>
  </div>
  <div class="p-d-flex p-jc-between p-mt-4">
    <p-vue-button
      class="button p-button-rounded p-button-success"
      :label="__('Save')"
      @click="save"
    />
    <p-vue-button
      class="button p-button-rounded p-button-success"
      :label="__('Cancel')"
      @click="close"
    />
  </div>
</template>

<script>
import { __ } from "@/plugins/i18n/";
import {
  errorReceived,
  isValidEmail,
  showSuccessOrFailedModal,
} from "@/services/apointUtil";
import { callProc, apiParam, apiPType } from "@/services/APointAPI";
import { mapState } from "vuex";

export default {
  props: {
    supplier: Object,
    close: Function,
    updateContact: Boolean,
  },
  emits: ["supplierUpdate"],
  data() {
    return {
      supplierLocal: {},
      groupsOptions: [],
      servicesOptions: [],
      errors: { Company: null, Email: null, SSID: null, GroupID: null },
      valid: true,
    };
  },
  mounted() {
    this.supplierLocal = this.supplier;
    this.getData();
  },
  methods: {
    getData() {
      this.$store.dispatch("doLoading", true);
      let procParams = [apiParam("UserNum", this.userNum, apiPType.Int)];
      callProc("WorkerApp_SupplierGroups", procParams)
        .then((result) => {
          result = JSON.parse(result);
          this.groupsOptions = result.Table;
          this.servicesOptions = result.Table1;
          if (this.IsEdit) {
            this.supplierLocal.GroupIDValue = this.groupsOptions.find(
              (f) => f.GroupID == this.supplier.GroupID
            );
            this.supplierLocal.ssTypeIDValue = this.servicesOptions.find(
              (f) => f.SSID == this.supplier.ssTypeID
            );
          } else {
            this.supplierLocal.GroupIDValue = this.groupsOptions[0];
            this.supplierLocal.ssTypeIDValue = this.servicesOptions[0];
          }
          // console.log(this.supplierLocal);
          this.$store.dispatch("doLoading", false);
        })
        .catch(() => {
          errorReceived("WorkerApp_SupplierGroups");
        });
    },
    validateFields() {
      this.valid = true;
      this.errors = { Company: null, Email: null, SSID: null, GroupID: null };
      if (!this.supplierLocal.Company) {
        this.valid = false;
        this.errors.Company = "Required field";
      }
      if (this.supplierLocal.Email && !isValidEmail(this.supplierLocal.Email)) {
        this.valid = false;
        this.errors.Email = "Invalid email address";
      }
      if (!this.supplierLocal.ssTypeIDValue) {
        this.valid = false;
        this.errors.SSID = "Required field";
      }
      if (!this.supplierLocal.GroupIDValue) {
        this.valid = false;
        this.errors.GroupID = "Required field";
      }
    },
    save() {
      this.validateFields();
      if (!this.valid) return;
      this.$store.dispatch("doLoading", true);
      let procParams = [
        apiParam("UserNum", this.userNum, apiPType.Int),
        apiParam("SupplierID", this.supplierLocal.SupplierID, apiPType.Int),
        apiParam("Company", this.supplierLocal.Company, apiPType.NVarChar),
        apiParam("SSID", this.supplierLocal.ssTypeIDValue?.SSID, apiPType.Int),
        apiParam("FirstName", this.supplierLocal.FirstName, apiPType.NVarChar),
        apiParam("LastName", this.supplierLocal.LastName, apiPType.NVarChar),
        apiParam("TelMobile", this.supplierLocal.TelMobile, apiPType.NVarChar),
        apiParam("TelWork", this.supplierLocal.TelWork, apiPType.NVarChar),
        apiParam("Address", this.supplierLocal.address, apiPType.NVarChar),
        apiParam("Position", this.supplierLocal.Position, apiPType.NVarChar),
        apiParam("FaxWork", this.supplierLocal.FaxWork, apiPType.NVarChar),
        apiParam("Email", this.supplierLocal.Email, apiPType.NVarChar),
        apiParam("WebSite", this.supplierLocal.Website, apiPType.NVarChar),
        apiParam("Notes", this.supplierLocal.Notes, apiPType.NVarChar),
        apiParam(
          "GroupID",
          this.supplierLocal.GroupIDValue?.GroupID,
          apiPType.Int
        ),
      ];
      callProc("WorkerApp_UpdateOrInsertSuppliers", procParams)
        .then((result) => {
          result = JSON.parse(result);
          // console.log("WorkerApp_UpdateOrInsertSuppliers", result);
          if (result.procReturnValue == 0) {
            showSuccessOrFailedModal(__("Power is successfully maintained"));
            setTimeout(() => {
              this.supplierLocal = result.Table[0];
              this.supplierLocal.Contacts = result.Table1;
              this.$emit("supplierUpdate", this.supplierLocal);
            }, 1000);
          } else {
            showSuccessOrFailedModal(__(result.Table[0].desc), false);
            setTimeout(() => {
              this.close();
            }, 2000);
          }
          this.$store.dispatch("doLoading", false);
        })
        .catch(() => {
          errorReceived("WorkerApp_UpdateOrInsertSuppliers");
        });
    },
  },
  computed: {
    IsEdit() {
      return this.supplier?.SupplierID ? true : false;
    },
    ...mapState({
      userNum: (state) => state.api.workerID,
    }),
  },
};
</script>

<style scoped>
.p-inputtextarea {
  width: 100%;
}

.icon:deep(.svg) {
  color: var(--color-success);
  width: 15px;
  height: 15px;
}

.grid {
  display: grid;
  grid-template-columns: 48% 48%;
  justify-content: space-between;
}
</style>
